// import external dependencies
import 'jquery';
import 'slick-carousel/slick/slick';
import '@fortawesome/fontawesome-free/js/all';
import 'offside-js';
import 'isotope-layout';
import 'vanilla-lazyload';
import 'popper.js';

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_masonry.js";

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import verbindetDebug from './routes/debugging';
import branchTemplateDefault from './routes/branch';
import archiveBranchData from './routes/branch';
import immobilien from './routes/immo';
import archiveLocalsData from './routes/locals';
import districtTemplateDefault from './routes/district';
import archiveDistrictData from './routes/district';
import immoprojectsTemplateDefault from './routes/immoprojects';
import archiveEventData from './routes/events';
import singleEvent from './routes/events';
import singlePost from './routes/blog';
import templateEventlist from './routes/eventflyer';
import templateEmma from './routes/emma';
import templateEmmaAll from './routes/emmaAll';
import templateOfflineData from './routes/templateOfflineData';
import templatePropertysearch from './routes/templatePropertysearch';
import templatePropertysearchresults from './routes/templatePropertysearch';
import templatePropertysingle from './routes/templatePropertysingle';
import adnordElementor from './routes/templateAdnordElementor';
import taxThemenwelten from './routes/themenwelten';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Branch pages
  verbindetDebug,
  branchTemplateDefault,
  archiveBranchData,
  // Immo Pages
  immobilien,
  // Archive Locals
  archiveLocalsData,
  // District pages
  districtTemplateDefault,
  archiveDistrictData,
  // Immoprojects pages
  immoprojectsTemplateDefault,
  archiveEventData,
  singlePost,
  singleEvent,
  // Eventlist Flyer Themplate
  templateEventlist,
  // Emma Newsletter Template
  templateEmma,
     // Emma Newsletter Template All
  templateEmmaAll,
  // Offline Data Template
  templateOfflineData,
  // template Property search
  templatePropertysearch,
  templatePropertysearchresults,
  templatePropertysingle,
  adnordElementor,
  // Taxonomy
  taxThemenwelten,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js